/**
 * CustomerPaymentMethodSelection — Large payment method buttons
 */
import React from 'react';

const METHOD_CONFIG = {
  card:    { label: 'Card',         icon: 'credit-card' },
  cash:    { label: 'Cash',         icon: 'banknotes' },
  qr:     { label: 'QR Pay',       icon: 'qr-code' },
  zelle:   { label: 'Zelle',        icon: 'smartphone' },
  venmo:   { label: 'Venmo',        icon: 'smartphone' },
  gift:    { label: 'Gift Card',    icon: 'gift' },
  loyalty: { label: 'Loyalty',      icon: 'star' },
  crypto:  { label: 'Crypto',       icon: 'bitcoin' },
};

const ICONS = {
  'credit-card': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="cfd-method-svg">
      <rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/>
    </svg>
  ),
  'banknotes': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="cfd-method-svg">
      <rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="3"/>
    </svg>
  ),
  'qr-code': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="cfd-method-svg">
      <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
      <rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="3" height="3"/>
      <rect x="18" y="18" width="3" height="3"/>
    </svg>
  ),
  'smartphone': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="cfd-method-svg">
      <rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/>
    </svg>
  ),
  'gift': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="cfd-method-svg">
      <rect x="3" y="8" width="18" height="4" rx="1"/><rect x="4" y="12" width="16" height="8" rx="1"/>
      <line x1="12" y1="8" x2="12" y2="20"/><path d="M12 8a4 4 0 00-4-4c-1.5 0-2 1-2 2s1.5 2 3 2h3"/>
      <path d="M12 8a4 4 0 014-4c1.5 0 2 1 2 2s-1.5 2-3 2h-3"/>
    </svg>
  ),
  'star': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="cfd-method-svg">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
  ),
  'bitcoin': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="cfd-method-svg">
      <circle cx="12" cy="12" r="10"/><text x="8" y="17" fontSize="12" fill="currentColor" stroke="none" fontWeight="bold">B</text>
    </svg>
  ),
};

export default function CustomerPaymentMethodSelection({ methods = [], total, onSelect, onBack }) {
  const fmt = (n) => `$${Number(n).toFixed(2)}`;

  return (
    <div className="cfd-panel cfd-slide-up" data-testid="payment-select-screen">
      <h2 className="cfd-heading">Select Payment</h2>
      <p className="cfd-total-display">{fmt(total)}</p>

      <div className="cfd-payment-grid">
        {methods.map((m) => {
          const cfg = METHOD_CONFIG[m] || { label: m, icon: 'credit-card' };
          return (
            <button
              key={m}
              onClick={() => onSelect(m)}
              className="cfd-payment-btn"
              data-testid={`pay-method-${m}`}
            >
              <div className="cfd-payment-icon">{ICONS[cfg.icon]}</div>
              <span className="cfd-payment-label">{cfg.label}</span>
            </button>
          );
        })}
      </div>

      <button onClick={onBack} className="cfd-link-btn" data-testid="back-to-tip-btn">Back</button>
    </div>
  );
}
